import { Target } from "lucide-react";
import type { WidgetDef } from "../types";
import { GoalGlance, GoalView } from "./GoalWidget";

export const goalWidget: WidgetDef<Record<string, never>> = {
  type: "goal",
  icon: Target,
  title: "goal.title",
  description: "goal.description",
  sizes: ["s", "m"],
  defaultSize: "s",
  defaultConfig: () => ({}),
  parseConfig: () => ({}),
  available: (me) => me.role !== "carrier",
  View: GoalView,
  Glance: GoalGlance,
};
